import { render, staticRenderFns } from "./search-tag.vue?vue&type=template&id=23ef1648&scoped=true&"
import script from "./search-tag.vue?vue&type=script&lang=ts&"
export * from "./search-tag.vue?vue&type=script&lang=ts&"
import style0 from "./search-tag.vue?vue&type=style&index=0&id=23ef1648&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ef1648",
  null
  
)

export default component.exports